import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";

import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import { SnackContext } from "context/SnackProvider";
import { ActivityTypeContext } from "context/CommonProvider";
import instance, { getErrorMessage } from "api/definitions";

const ActivityCardLoad = (props) => {
  const [changeFields, setChangeFields] = useState(false);
  const [changeCategory, setChangeCategory] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [activityType, setActivityType] = useState([]);

  const snackContext = useContext(SnackContext);
  const activityTypeContext = useContext(ActivityTypeContext);

  useEffect(() => {
    setIsLoaded(false);
    if (props.id) {
      const fullURL = `atividade/${props.id}`;
      instance
        .get(fullURL)
        .then(function (response) {
          setIsLoaded(true);
          const result = response.data;
          const idActivityType = result.idAtividadeTipo;
          setActivityType(activityTypeContext[idActivityType]);

          setItems(result);
          setChangeFields(false);
          setChangeCategory(false);
          if (idActivityType === 2) {
            setChangeFields(true);
          } else if (idActivityType === 1) {
            setChangeCategory(true);
          }
        })
        .catch(function (error) {
          setIsLoaded(true);
          const msg = getErrorMessage(error);
          snackContext.setMessage(msg, "error");
        });
    }
  }, [props.id, snackContext, activityTypeContext]);

  if (!isLoaded) {
    return <CircularProgress />;
  } else {
    return (
      <Card raised id={props.idActivity} sx={{ mt: 1, mb: 2, minWidth: 300 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item>
              <strong>Nome:</strong> {items.nome}
            </Grid>
            <Grid item>
              <strong>Tipo:</strong> {activityType}
            </Grid>
            {changeCategory && (
              <Grid item>
                <strong>Categoria:</strong>{" "}
                {items.categoria ? items.categoria : "Nenhuma"}
              </Grid>
            )}
            <Grid item>
              <strong>Solicitante:</strong>{" "}
              {Number(items.nomeSolicitante)
                ? "Sem nome"
                : items.nomeSolicitante.toUpperCase()}
            </Grid>
            {items.division && (
              <Grid item>
                <strong>Divisão:</strong> {items.divisao}
              </Grid>
            )}
            <Grid item>
              <strong>Participantes:</strong> {items.participantes}
            </Grid>
            <Grid item>
              <strong>Descrição:</strong>{" "}
              {items.descricao ? items.descricao : "(Não informada)"}
            </Grid>

            {changeFields && (
              <>
                <Grid item>
                  <strong>Unidade:</strong> {items.subclass.unidade}
                </Grid>
                <Grid item>
                  <strong>Divisão:</strong> {items.subclass.divisao}
                </Grid>
                <Grid item>
                  <strong>Turma:</strong> {items.subclass.turma}
                </Grid>
                <Grid item>
                  <strong>Semestre:</strong> {items.subclass.semestre}
                </Grid>
                <Grid item>
                  <strong>Disciplina:</strong> {items.subclass.disciplina}
                </Grid>
              </>
            )}
          </Grid>
        </CardContent>
      </Card>
    );
  }
};

ActivityCardLoad.defaultProps = {
  idActivity: undefined,
};

ActivityCardLoad.propTypes = {
  idActivity: PropTypes.string,
};

export default ActivityCardLoad;
